// The Inventory Auction filter's "None" option: the URL value and label for lots in no auction.
// One owner for the repository's SQL arm and the facet list (BL-2855).

/**
 * The `auctionId` filter value meaning "lots in no auction". Not a uuid, so it can never
 * collide with a real auction id (same shape as `UNASSIGNED_RING_FILTER_VALUE`).
 */
export const NO_AUCTION_FILTER_VALUE = 'none';

/** The Auction filter's label for {@link NO_AUCTION_FILTER_VALUE}. */
export const NO_AUCTION_FILTER_LABEL = 'None';

/**
 * The one real auction a filter selection is scoped to, else null. The lot-sequence default
 * order only makes sense inside ONE auction, so a lone "None" (lots in no auction) is not one.
 *
 * @param auctionIds - The parsed `auctionId` filter list, `none` included.
 * @returns The auction id when the list is exactly one real id, otherwise null.
 */
export function singleRealAuctionId(auctionIds: readonly string[] | null | undefined): string | null {
  if (auctionIds?.length !== 1) return null;
  return auctionIds[0] === NO_AUCTION_FILTER_VALUE ? null : auctionIds[0];
}
